<template>
  <b-card border-variant="light" class="card px-0">
    <b-card-text>
      <h3 class="title">{{ title }}</h3>
      <span v-for="(amount, currencyCode) in data" :key="currencyCode" class="chip">
        {{ amount }} {{currencyCode}}
      </span>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 10px;
}

.card {
  :global(.card-body) {
    padding-top: 10px;
  }
}

.card .title {
  font-size: 18px;
  margin-bottom: 13px;
}

.chip {
  margin-right: 5px;
  padding: 8px 11px;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: $fontColor2;
  border-radius: 10px;
  background-color: $bgColorBase;
}
</style>
